class NewsletterSignupElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput && !emailInput.value) {
          e.preventDefault();
        }
      });
    }
  }
}

if (!customElements.get('newsletter-signup-form')) {
  customElements.define('newsletter-signup-form', NewsletterSignupElement);
}
